import React from "react";
import { View, Linking } from "react-native";
import { hasItems, isWeb } from "../../../helpers/utils";

import appStyles from "../../appStyles";
import CarouselProgressBar from "../animation/progressBar/CarouselProgressBar";

import ManaGiftDialog from "./customize/ManaGiftDialog";
import Intro from "./customize/Intro";
import CustomizeElementsHelper from "./customize/CustomizeElementsHelper";
import Question from "./customize/Question";
import ElementsTreeView from "./customize/TreeViewElements";
import Summary from "./customize/Summary";
import CustomizeLifeDialog from "./customize/CustomizeLifeDialog";
import QuickElementCreationDialog from "./customize/QuickElementCreationDialog";
import ProgressBarConfig from "../animation/progressBar/config";
import SettingsHelper from "../more/SettingsHelper";
import SetupConfig from "../home/cards/onboarding/SetupConfig";
import AppConfig from '../../../config/AppConfig';

export default class CustomizeElementsPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    const currentUser =
      this.controller.state?.settings?.nickname ||
      this.controller.state?.currentUser;

    const hasTeam = this.controller.state?.settings?.hasTeam;

    this.state = {
      showGiftDialog: false,
      questionIndex: -1,
      questions: [],
      currentUser,
      hasTeam,
    };

    CustomizeElementsHelper.getQuestions(this.controller, (questions) => {
      this.setState((state) => ({ ...state, questions: questions || [] }));
    });
    this.refreshElements();
  }

  toggleGiftDialog = (showGiftDialog) => {
    this.setState((state) => ({ ...state, showGiftDialog }));
  };

  toggleLifeDialog = (showCustomizeLifeDialog) => {
    this.setState((state) => ({ ...state, showCustomizeLifeDialog }));
  };

  markAsPersonal = () => {
    this.toggleLifeDialog(null);
    this.toggleGiftDialog(true);

    // Set a flag in our system to track all non-work time as “personal”
    const action = {
      action: "save",
      target: "question",
      use_non_work_as_personal: true,
    };

    this.controller.cardActionWithCallback(action, (data, response) => {
      this.refreshElements();
    });
  };

  goHome = () => {
    this.controller.navigate("feed");
  };

  scheduleCall = () => {
    this.toggleGiftDialog(null);

    if (isWeb) {
      window.open(AppConfig.STRIPE_URL, "_blank");
    } else {
      Linking.openURL(AppConfig.STRIPE_URL);
    }
  };

  goBack = () => {
    const { questionIndex } = this.state;

    let index = questionIndex - 1;

    if (index < -1) {
      return this.controller.goBack();
    }
    this.changeScreen({ questionIndex: index });
  };

  changeScreen = (data) => {
    const { questions } = this.state;
    let showSummary = this.state.showSummary || data.showSummary;

    if (data.questionIndex) {
      if (data.questionIndex < questions.length) {
        showSummary = false;
      } else if (data.questionIndex > questions.length) {
        data.questionIndex = questions.length;
        showSummary = true;
      }
    }

    this.setState((state) => ({
      ...state,
      ...data,
      showSummary: showSummary,
      showCustomizeLifeDialog: false,
    }));
  };

  // ------------------------------------- CREATE ELEMENT -------------------------------------
  toggleCreateElementDialog = (elementParentId) => {
    this.setState((state) => ({ ...state, elementParentId }));
  };

  createElement = (element) => {
    const { elementParentId } = this.state;
    if (!elementParentId) return;

    const elementModel = {
      ...element,
      edit_is_active: "checked",
      parents: [elementParentId],
    };

    this.toggleCreateElementDialog(null);

    this.controller.cardActionWithCallback(
      {
        action: "save",
        target: "element",
        ...elementModel,
      },
      (data, response) => {
        this.refreshElements();
      },
    );
  };

  refreshElements() {
    CustomizeElementsHelper.getElements(
      this.controller,
      this.state.questionIndex + 1,
      (data) => {
        this.setState({ elements: data });
      },
    );
  }

  onContinueToMana = (isFinalStep) => {
    // Save current step in settings for checklist display
    SettingsHelper.updateSetupProgress(this.controller, {
      [SetupConfig.elements.name]: true,
    });

    if (isFinalStep) {
      this.toggleGiftDialog(true);
    } else {
      this.toggleLifeDialog(true);
    }
  };

  render() {
    const {
      currentUser,
      showGiftDialog,
      showCustomizeLifeDialog,
      elementParentId,
      questions,
      elements,
      showSummary,
      questionIndex,
      hasTeam,
    } = this.state;

    const selectedQuestion =
      hasItems(questions) && questionIndex < questions.length
        ? questions[questionIndex]
        : null;

    const isTreeView = selectedQuestion && selectedQuestion.is_tree;
    const isFinalStep =
      hasItems(questions) && questionIndex >= questions.length - 1;

    const currentScreenIndex = ProgressBarConfig["customizeElements"];
    const numberOfScreens = Object.keys(ProgressBarConfig).length;

    return (
      <View style={appStyles.container}>
        <CarouselProgressBar
          currentScreenIndex={currentScreenIndex}
          numberOfScreens={numberOfScreens}
          changeScreen={this.goBack}
          hideNext
        />

        {showSummary || (selectedQuestion && selectedQuestion.is_continue) ? (
          <Summary
            onContinue={() => this.onContinueToMana(isFinalStep)}
            onCustomize={() =>
              this.changeScreen(
                questionIndex < questions.length - 1
                  ? { questionIndex: questionIndex + 1 }
                  : { showSummary: true },
              )
            }
            isFinalStep={isFinalStep}
          />
        ) : isTreeView ? (
          <ElementsTreeView
            elements={elements}
            userName={currentUser}
            onContinue={() =>
              this.changeScreen(
                questionIndex < questions.length - 1
                  ? { questionIndex: questionIndex + 1 }
                  : { showSummary: true },
              )
            }
            isFinalStep={isFinalStep}
            openCreateElementDialog={this.toggleCreateElementDialog}
          />
        ) : selectedQuestion ? (
          <Question
            controller={this.controller}
            question={selectedQuestion}
            onContinue={() => {
              this.refreshElements();
              this.changeScreen({ questionIndex: questionIndex + 1 });
            }}
          />
        ) : (
          <Intro
            onContinue={() =>
              this.changeScreen({
                questionIndex: questionIndex + (hasTeam ? 2 : 1),
              })
            }
          />
        )}

        {showGiftDialog ? (
          <ManaGiftDialog
            controller={this.controller}
            onCancel={this.goHome}
            onScheduleCall={this.scheduleCall}
            close={() => this.toggleGiftDialog(null)}
          />
        ) : null}

        {showCustomizeLifeDialog ? (
          <CustomizeLifeDialog
            controller={this.controller}
            markAsPersonal={this.markAsPersonal}
            onContinue={() =>
              this.changeScreen(
                questionIndex < questions.length - 1
                  ? { questionIndex: questionIndex + 1 }
                  : { showSummary: true },
              )
            }
            close={() => this.toggleLifeDialog(null)}
          />
        ) : null}
        {elementParentId ? (
          <QuickElementCreationDialog
            createElement={this.createElement}
            close={() => this.toggleCreateElementDialog(null)}
          />
        ) : null}
      </View>
    );
  }
}
